export default __webpack_public_path__ + "static/media/gloryforkorn--og--404.e1a65b8c.jpg";